import { render, staticRenderFns } from "./ImageShare.vue?vue&type=template&id=4bdc24f6&scoped=true"
import script from "./ImageShare.vue?vue&type=script&lang=js"
export * from "./ImageShare.vue?vue&type=script&lang=js"
import style0 from "./ImageShare.vue?vue&type=style&index=0&id=4bdc24f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc24f6",
  null
  
)

export default component.exports